import { Link } from "react-router-dom";
import NewsletterForm from "@/components/NewsletterForm";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#E0D6BD] border-t border-[#1F2A1B]/10 mt-32"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-16 py-24">
        {/* Footer statement */}
        <div className="mb-20 max-w-4xl">
          <img
            src="/logo.png"
            alt="Carbon on Country"
            data-testid="footer-logo"
            className="h-40 md:h-48 w-auto object-contain mb-10 -ml-2"
          />
          <p className="overline mb-6">Carbon on Country</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#1F2A1B] mb-8">
            Caring for Country.
            <br />
            <span className="italic text-[#3F5132]">Measuring Change.</span>
            <br />
            Building Capability.
          </h2>
          <p className="text-[#4F5A48] max-w-2xl text-base md:text-lg leading-relaxed">
            Carbon on Country supports Indigenous ranger programs and Traditional
            Owner organisations to build the skills needed for carbon markets,
            biodiversity investment, natural capital management and environmental
            stewardship.
          </p>
          <p className="font-serif italic text-2xl md:text-3xl text-[#C45A3C] mt-10">
            Country needs people who can measure change.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 border-t border-[#1F2A1B]/10 pt-16">
          <div className="lg:col-span-5">
            <p className="overline mb-4">Stay informed</p>
            <h3 className="font-serif text-2xl md:text-3xl text-[#1F2A1B] mb-6 leading-tight">
              Field notes from the
              <br />
              environmental workforce frontier.
            </h3>
            <NewsletterForm />
          </div>

          <div className="lg:col-span-2">
            <p className="overline mb-5">Explore</p>
            <ul className="space-y-3 text-[#4F5A48]">
              <li><Link to="/" data-testid="footer-home" className="hover:text-[#3F5132] transition-colors">Home</Link></li>
              <li><Link to="/pathways" data-testid="footer-pathways" className="hover:text-[#3F5132] transition-colors">Pathways</Link></li>
              <li><Link to="/pathways/native-seed-collection" data-testid="footer-seed" className="hover:text-[#3F5132] transition-colors">Seed Training</Link></li>
              <li><Link to="/services" data-testid="footer-services" className="hover:text-[#3F5132] transition-colors">Services</Link></li>
              <li><Link to="/leadership" data-testid="footer-leadership" className="hover:text-[#3F5132] transition-colors">Leadership</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="hover:text-[#3F5132] transition-colors">About</Link></li>
              <li><Link to="/resources" data-testid="footer-resources" className="hover:text-[#3F5132] transition-colors">Resources</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="overline mb-5">For</p>
            <ul className="space-y-3 text-[#4F5A48]">
              <li>Ranger Programs</li>
              <li>Traditional Owners</li>
              <li>Indigenous Corporations</li>
              <li>Workforce Development</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="overline mb-5">Connect</p>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="inline-flex items-center gap-2 text-[#1F2A1B] hover:text-[#C45A3C] transition-colors group"
            >
              <span className="font-serif text-2xl">Start a conversation</span>
              <ArrowUpRight size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
            <p className="text-[#8A8775] text-sm mt-6 leading-relaxed">
              Building skills. Building confidence. Building capability. Building pathways.
            </p>
          </div>
        </div>

        <div className="border-t border-[#1F2A1B]/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-[#8A8775] text-xs tracking-widest uppercase">
            © {new Date().getFullYear()} Carbon on Country
          </p>
          <p className="text-[#8A8775] text-xs italic font-serif">
            We acknowledge Traditional Owners of Country throughout Australia and
            recognise their continuing connection to lands, waters and communities.
          </p>
        </div>
      </div>
    </footer>
  );
}
